import { render } from "./ProductCarousel.vue?vue&type=template&id=f2410dac&scoped=true"
import script from "./ProductCarousel.vue?vue&type=script&lang=js"
export * from "./ProductCarousel.vue?vue&type=script&lang=js"

import "./ProductCarousel.vue?vue&type=style&index=0&id=f2410dac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2410dac"]])

export default __exports__